import { z } from 'zod';
export const userRefSchema = z.object({
    id: z.string(),
    email: z.string(),
});
export const userAccountRefSchema = z.object({
    id: z.string(),
    user: userRefSchema,
});
